import { ChangeDetectionStrategy, Component, OnInit, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router, NavigationEnd } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';
import { signal } from '@angular/core';

@Component({
  selector: 'app-internal-after',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule],
  templateUrl: './internal-after.component.html',
  styleUrl: './internal-after.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InternalAfterComponent implements OnInit {
  private router = inject(Router);
  
  // Signal to track if we should show the title
  showTitle = signal(true);

  ngOnInit(): void {
    // Check initial route
    this.updateTitleVisibility();
    
    // Listen to route changes
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateTitleVisibility();
      });
  }

  private updateTitleVisibility(): void {
    const url = this.router.url;
    // Hide title when on view page
    const isViewPage = url.includes('/return/view/');
    this.showTitle.set(!isViewPage);
  }
}
